import { render, staticRenderFns } from "./Telecomunicacoes.vue?vue&type=template&id=6993ded9&"
import script from "./Telecomunicacoes.vue?vue&type=script&lang=js&"
export * from "./Telecomunicacoes.vue?vue&type=script&lang=js&"
import style0 from "./Telecomunicacoes.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports